import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { SuppliersPage } from './_dashboard.catalog.suppliers'

export const Route = createFileRoute('/_dashboard/catalog/suppliers/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: SuppliersIndexPage,
})

function SuppliersIndexPage() {
  return <SuppliersPage selectedId={undefined} />
}
